import React from 'react';
import { Drawer, Checkbox, Space, Divider } from 'antd';

const ValueReuseComponent = ({ 
  visible, 
  onClose, 
  title = "Value选项",
  checkboxGroups = [],
  selectedValues = {},
  onCheckboxChange
}) => {
  return (
    <Drawer
      title={title}
      placement="top"
      height="80%"
      onClose={onClose}
      open={visible}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {checkboxGroups.map((group, groupIndex) => (
          <div key={groupIndex}>
            <div style={{ fontWeight: 'bold', marginBottom: 8, color: '#1890ff' }}>
              {group.categoryName}
            </div>
            <Checkbox.Group 
              options={group.options}
              value={selectedValues[group.categoryName] || []}
              onChange={(checkedValues) => onCheckboxChange(group.categoryName, checkedValues)}
              style={{ marginLeft: 16 }}
            />
            {groupIndex < checkboxGroups.length - 1 && <Divider style={{ margin: '12px 0' }} />}
          </div>
        ))}
      </Space>
    </Drawer>
  );
};

export default ValueReuseComponent;